export const getDataTasks = (app) => (baseQuery) =>
  (filter, activeDate) => {
    let userIds = []
    if (filter && filter.userIds) {
      userIds = filter.userIds
    }
    const query = {
      ...baseQuery,
      userId: userIds && userIds.length > 0 ? userIds : undefined,
      completed: filter.status && filter.status.length === 1 ? filter.status[0] === 'closed' : undefined,
      schedules: activeDate ? {
        $elemMatch: {
          date: {
            $gte: new Date(
              activeDate.getFullYear(),
              activeDate.getMonth(),
              activeDate.getDate()
            ),
            $lt: new Date(
              activeDate.getFullYear(),
              activeDate.getMonth(),
              activeDate.getDate() + 1
            )
          }
        }
      } : undefined
    }

    return app
      .service('/api/project/plannertask')
      .find({
        query
      })
      .catch(timeErr => {
        app.error('PageTask: _getDataTasks Error', timeErr)
      })
  }
